import { createContext, useContext, useState, ReactNode } from "react";
import { LoginAuthContextType } from "../types/context";

const LoginAuthContext = createContext<LoginAuthContextType | undefined>(
  undefined
);

interface LoginAuthProviderProps {
  children: ReactNode;
}

function LoginAuthProvider({ children }: LoginAuthProviderProps) {
  const [mobileNumber, setMobileNumber] = useState<string>("");

  return (
    <LoginAuthContext.Provider
      value={{
        mobileNumber,
        setMobileNumber,
      }}
    >
      {children}
    </LoginAuthContext.Provider>
  );
}

function useLoginAuth() {
  const context = useContext(LoginAuthContext);
  if (context === undefined) {
    throw new Error("LoginAuthContext was used outside of LoginAuthProvider");
  }
  return context;
}

export { LoginAuthProvider, useLoginAuth };
